import { Hexagon } from "lucide-react";

const ITEMS = [
  "Acoustic Insulation",
  "Multi-Point Locking",
  "UV-Stabilized Profiles",
  "Thermal Efficiency",
  "Custom Laminate Foils",
  "Monsoon-Proof Sealing",
  "Galvanized Steel Core",
  "20-Year Warranty",
];

export const Marquee = () => (
  <div className="relative border-y border-border bg-surface/60 py-5 overflow-hidden" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-heading text-sm sm:text-base font-medium tracking-[0.2em] uppercase text-slate-500">
            {item}
          </span>
          <Hexagon className="h-3 w-3 text-gold/60" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  </div>
);
